module.exports = "/images/igSocial.png?139eb881e3a0a267bf5b8dd07f6e2343";